import { createConsoleLogHandler, defaultLogger, LogLevel } from '@sky-uk-ott/core-video-sdk-js-logger';
/**
 * @public
 */ export var sdkLogger = defaultLogger.withContext('SDK');
export { createConsoleLogHandler, LogLevel };

//# sourceMappingURL=logger.js.map